import { useEffect, useState } from "react";
import axiosInstance from "../../../../services/AxiosInstance";
import Api from "../../../../constants/Api";

/**
 * Logo e nome da empresa logada para o cabeçalho dos documentos de relatório.
 *
 * A logo vem como data URL porque o PDF é impresso em uma janela nova, sem o token da
 * sessão: uma URL autenticada carregaria em branco lá. Empresa sem logo apenas não mostra
 * imagem, e falha em qualquer uma das chamadas não impede a emissão do documento, que é
 * o que importa no papel.
 */
const useCompanyBranding = () => {

    const [branding, setBranding] = useState({ name: null, logo: null });

    useEffect(() => {
        let active = true;

        axiosInstance.get(Api.registration.company_info)
            .then(({ data }) => { if (active) setBranding(current => ({ ...current, name: data?.name || null })); })
            .catch(() => { });

        // A logo é pedida direto, sem consultar antes se a empresa tem uma: empresa sem
        // logo responde 404, tratado como ausência, e assim a imagem não depende de a
        // resposta de /info trazer a flag.
        axiosInstance.get(Api.registration.company_logo, { responseType: 'blob' })
            .then(({ data: blob }) => {
                // A checagem de tipo evita que um corpo inesperado vire imagem quebrada.
                if (!active || !blob || blob.size === 0 || !String(blob.type).startsWith('image/')) return;
                const reader = new FileReader();
                reader.onloadend = () => { if (active) setBranding(current => ({ ...current, logo: reader.result })); };
                reader.readAsDataURL(blob);
            })
            .catch(() => { });

        return () => { active = false; };
    }, []);

    return branding;
};

export default useCompanyBranding;
